import { render, staticRenderFns } from "./GameN.vue?vue&type=template&id=364e270c&scoped=true&"
import script from "./GameN.vue?vue&type=script&lang=js&"
export * from "./GameN.vue?vue&type=script&lang=js&"
import style0 from "./GameN.vue?vue&type=style&index=0&id=364e270c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e270c",
  null
  
)

export default component.exports